import {Component} from "@angular/core";
import {FUIFormContext} from "./form-context";
import {FUIInlineActionFormContext} from "./inline-action-form-context";

@Component({
    selector: "fui-inline-action-form-context",
    template: "<ng-content></ng-content>",
    providers: [{ provide: FUIFormContext, useClass: FUIInlineActionFormContext }],
    standalone: false
})
export class FUIInlineActionFormContextComponent {
}
